var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"breadcrumbs"},[_c('ul',{staticClass:"breadcrumbs__list"},_vm._l((_vm.navList),function(item,idx){return _c('li',{key:`breadcrumb-${idx}`,staticClass:"breadcrumbs__item"},[_c('a',{attrs:{"href":item.pathLink}},[_vm._v(_vm._s(item.label))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }